// extracted by mini-css-extract-plugin
export var intro__light_bulbs = "introduction-mod--intro__light_bulbs--26VEx";
export var intro = "introduction-mod--intro--2ebiZ";
export var intro__main = "introduction-mod--intro__main--3Au1T";